module.exports = __webpack_public_path__ + "img/plus_icon.3d3f20bf.jpg";